export default __webpack_public_path__ + "2db2f745ac8e8039d56ca920a963d426.svg";